export type UsuarioRole = 'ADMIN' | 'GERENTE' | 'CONSULTOR' | 'OPERADOR'

/**
 * Papel COMPLEMENTAR do GERENTE (AN-8 §4): gestão de campanhas, metas e ranking da própria
 * equipe. Não é papel único — aparece em `roles` junto de GERENTE.
 */
export const PAPEL_GESTOR_EQUIPE = 'GESTOR_EQUIPE'

export interface UsuarioAdmin {
  id: string
  email: string
  nome: string
  firstName?: string
  lastName?: string
  enabled: boolean
  emailVerified?: boolean
  tipoCanal?: string | null
  cpf?: string | null
  cnpj?: string | null
  /** Tenant (empresa) — obrigatório para CONSULTOR. */
  tenantId?: string | null
  roles: string[]
}

export interface UsuarioCreateRequest {
  email: string
  nome: string
  senha: string
  tipoCanal?: string | null
  cpf?: string | null
  cnpj?: string | null
  tenantId?: string | null
  role: UsuarioRole
  /** Concede GESTOR_EQUIPE junto. `true` exige role GERENTE (422 GESTOR_EQUIPE_SO_GERENTE). */
  gestorEquipe?: boolean | null
}

export interface UsuarioUpdateRequest {
  nome: string
  tipoCanal?: string | null
  cpf?: string | null
  cnpj?: string | null
  tenantId?: string | null
  enabled?: boolean
  novaSenha?: string | null
  role: UsuarioRole
  /**
   * GESTOR_EQUIPE: `true` concede (só GERENTE), `false` remove, `null`/ausente mantém.
   * Trocar o papel para não GERENTE remove automaticamente no backend.
   */
  gestorEquipe?: boolean | null
}
